export class BscNotificationUserEntity{
    id:number;
    notificationId:number;
    userId:number;
    user:string;
    mail:string;

    constructor(){}
}